import React from "react";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {s_char} from "../_signals/s_char";
import {useSignals} from "@preact/signals-react/runtime";
import updChar from "../_sig_api/updChar";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

export default function CharVisible() {

    useSignals();

    return <Item>
        <label>visible</label>
        <input
            type="checkbox"
            checked={s_char.value.visible}
            onChange={(event) => updChar([{k:'visible',v: event.target.checked}])}
        />
    </Item>
}
